import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from 'recharts';

import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from '@/components/ui/chart';

import dayjs from 'dayjs';

type Props = {
  chartData: any[];
  chartConfig: ChartConfig;
  startTime: number;
  latestTime: number;
  isTicksCenter?: boolean;
};
export function BarChartTotal({
  chartConfig,
  chartData,
  latestTime,
  startTime,
  isTicksCenter,
}: Props) {
  // const startTime = latestTime - 24 * 60 * 60 * 1000;
  const xDomain = [startTime, latestTime];

  return (
    <ChartContainer config={chartConfig} className="max-h-[300px] w-full">
      <BarChart
        accessibilityLayer
        data={chartData}
        margin={{
          left: 12,
          right: 12,
        }}
      >
        <CartesianGrid vertical={false} />
        <XAxis
          dataKey="date"
          tickLine={false}
          axisLine={false}
          tickMargin={8}
          minTickGap={32}
          tickFormatter={(value) => dayjs.unix(value).format('DD MMM, HH:mm')}
          scale={'time'}
          name="hour"
          domain={xDomain}
          type="number"
          ticks={
            isTicksCenter
              ? [startTime, ...chartData.map((item) => item.date), latestTime]
              : [startTime, latestTime]
          }
        />
        <YAxis tickLine={false} axisLine={false} tickMargin={8} tickCount={3} />
        <ChartTooltip
          content={
            <ChartTooltipContent
              className="w-[200px]"
              labelFormatter={(_, payload) => {
                return dayjs
                  .unix(payload[0]?.payload.date)
                  .format('DD MMM, HH:mm');
              }}
            />
          }
        />
        {Object.entries(chartConfig).map(([key, config]) => (
          <Bar
            key={key}
            stackId="a"
            dataKey={key}
            type="monotone"
            fill={config.color}
            maxBarSize={16}
          />
        ))}
      </BarChart>
    </ChartContainer>
  );
}

export default BarChartTotal;
